import { render } from "./ConfirmDiscardChanges.vue?vue&type=template&id=3ef64a2f&ts=true"
import script from "./ConfirmDiscardChanges.vue?vue&type=script&lang=ts"
export * from "./ConfirmDiscardChanges.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\src\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__